module.exports = __webpack_public_path__ + "static/img/produce14.b70d90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce14.png
// module id = 144
// module chunks = 4